module.exports = __webpack_public_path__ + "images/avatars/female/14.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/14.png
// module id = z7A8
// module chunks = 51